import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import MuiAppBar from "@mui/material/AppBar";
import { Box, List as MuiList, IconButton, Drawer } from "@mui/material";
import { WinDims } from "../../hooks/Method";
import { MenuRounded } from "@mui/icons-material";
import "./Dashboard.scss";
import { no_img } from "../../assets";

const List = styled(MuiList)({
  "&": {
    margin: "5px",
  },
  "& .MuiListItemButton-root": {
    borderRadius: "10px",
    marginBottom: "0px",
    "&, & .MuiListItemIcon-root": {
      color: "var(--gray-color)",
      minWidth: "40px",
    },
  },
  // hover states
  "& .MuiListItemButton-root:hover": {
    "&, & .MuiListItemIcon-root": {
      color: "var(--primaryDark-color)",
    },
    "& .MuiListItemText-root .MuiTypography-root": {
      fontWeight: "500",
      color: "var(--primaryDark-color)",
    },
  },
});

const drawerWidth = 280;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  top: "inherit",
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

export default function Dashboard(props) {
  const {
    menu,
    header,
    children,
    logo = no_img,
    showNav = true,
    ...other
  } = props;
  const minWidth = 950;
  const windowDims = WinDims().width;
  const [open, setOpen] = useState(
    showNav && (windowDims > minWidth ? true : false)
  );
  const toggleDrawer = () => {
    setOpen(!open);
  };

  useEffect(() => {
    showNav && setOpen(windowDims > minWidth ? true : false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [windowDims]);

  return (
    <div style={{ display: "flex" }} {...other}>
      {/* --- Navbar --- */}
      <AppBar open={open} className="appbar">
        <div className="appbar-container">
          <div className="appbar-inner-div">
            <div className="ml-10">
              {showNav && (
                <IconButton onClick={toggleDrawer} size="small">
                  <MenuRounded />
                </IconButton>
              )}
            </div>
            {showNav && header}
          </div>
        </div>
      </AppBar>

      {/* --- Menu --- */}
      <Drawer
        open={open}
        onClose={() => setOpen(!open)}
        variant="persistent"
        sx={{
          "& .MuiDrawer-paper": {
            display: open ? "block" : "none",
            width: "280px",
            position: { md: "relative", xs: "" },
            backgroundColor: "inherit",
            border: "none",
            boxShadow: "none",
            borderRadius: "0px",
          },
        }}
      >
        <div
          className="m-10 bg-white br-15"
          style={{ border: "1px solid var(--primaryMD-color)" }}
        >
          <div className="p-15 mb-15 tx-center">
            <img alt="company-logo" src={logo} className="h-80 obj-contain" />
          </div>
          <List
            sx={{
              height: "calc(100vh - 165px)",
              overflow: "auto",
              mb: "10px !important",
              p: "0px 5px 0px 5px",
            }}
          >
            {menu}
          </List>
        </div>
      </Drawer>

      {/* --- Body --- */}
      <Box
        component="main"
        className="bg-inherit p-20 pt-90 w-100pr mt-70"
        sx={{
          overflow: "auto",
          height: "calc(100vh - 110px)",
        }}
      >
        {children}
      </Box>
    </div>
  );
}
